<script lang="ts">
import { FormKit } from '@formkit/vue'
import { getTranslationsInjectionKey } from '@monogrid/vue-boost/i18n'
import { useStorage } from '@vueuse/core'
import { defineComponent, inject } from 'vue'
import { useRouter } from 'vue-router'

import CtaPrimary from '@/components/atoms/CtaPrimary.vue'

import FormProvider from '../atoms/FormProvider.vue'
export default defineComponent({
  name: 'LanguageBanner',
  components: {
    CtaPrimary,
    FormKit,
    FormProvider
  },
  setup (props, { attrs, slots, emit }) {
    const locales = inject(getTranslationsInjectionKey)()
    const store = useStorage('banner-select-lang', false)
    const router = useRouter()
    const submit = (data) => {
      router.push({ params: { locale: data.lang } })
      store.value = true
    }

    return {
      options: Object.entries(locales).map(([key, value]) => ({ label: value.name + (key === 'en' ? '' : '*'), value: key })),
      submit,
      store
    }
  }
})
</script>

<template>
  <Transition>
    <div
      v-if="!store"
      class="banner bg-blue c-white fixed left-0 right-0 bottom-0 p-4 flex lt-sm:flex-col lt-sm:gap-2 sm:items-center sm:justify-between"
    >
      <div>
        <h5 class="h5">Choose your language</h5>
      </div>
      <div>
        <FormProvider>
          <FormKit
            form-class="w-full"
            type="form"
            :actions="false"
            @submit="submit"
          >
            <div class="flex gap-2">
              <FormKit
                :value="$i18n.locale || 'en'"
                type="select"
                name="lang"
                outer-class="lang !w-20"
                :options="options"
                validation="required"
              />
              <CtaPrimary
                type="submit"
                green
              >
                Confirm
              </CtaPrimary>
            </div>
          </FormKit>
        </FormProvider>
        <p class="mt-2 c-grey">*AI Intelligence</p>
      </div>
    </div>
  </Transition>
</template>

<style lang="scss" scoped>
.banner {
  z-index: $z-lang-banner;
}

::v-deep(.formkit-messages){
  display: none;
}
</style>
